import React, { useEffect } from "react";
import "../styles/AboutUs.css";
import MainHeader from "../components/Main/MainHeader";
import HomeFooter from "../components/Home/HomeFooter";
import { Helmet } from "react-helmet-async";

export default function AboutUs() {
  // useEffect(() => {
  //   // ✅ SEO Meta Tags
  //   document.title = "About Us | Anyworq – A to Z Services in Bangalore";

  //   const metaDescription = document.createElement("meta");
  //   metaDescription.name = "description";
  //   metaDescription.content =
  //     "Learn about Anyworq – Bangalore’s trusted A-to-Z service marketplace. Discover our vision, mission, values, verified dealer system, and how we connect customers with reliable professionals across home, business, personal, and specialized services.";
  //   document.head.appendChild(metaDescription);

  //   const metaKeywords = document.createElement("meta");
  //   metaKeywords.name = "keywords";
  //   metaKeywords.content =
  //     "Anyworq Bangalore, About Anyworq, A to Z services Bangalore, verified dealers Bangalore, home services Bangalore, business services Bangalore, service marketplace India, trusted service providers Bangalore";
  //   document.head.appendChild(metaKeywords);

  //   // ✅ Schema Markup
  //   const script = document.createElement("script");
  //   script.type = "application/ld+json";
  //   script.innerHTML = JSON.stringify({
  //     "@context": "https://schema.org",
  //     "@type": "Organization",
  //     name: "Anyworq",
  //     url: "https://www.anyworq.com",
  //     logo: "https://www.anyworq.com/Favicon.png",
  //     sameAs: [
  //       "https://www.facebook.com/anyworq",
  //       "https://www.instagram.com/anyworq",
  //       "https://www.linkedin.com/company/anyworq"
  //     ],
  //     description:
  //       "Anyworq is Bangalore’s first-of-its-kind A-to-Z service marketplace, connecting customers with verified service providers across home, business, personal, and specialized services.",
  //     address: {
  //       "@type": "PostalAddress",
  //       addressLocality: "Bangalore",
  //       addressCountry: "India"
  //     },
  //     areaServed: {
  //       "@type": "Place",
  //       name: "Bangalore, India"
  //     },
  //     foundingDate: "2025",
  //     slogan: "One Platform. All Services. Bangalore’s Choice.",
  //   });
  //   document.head.appendChild(script);

  //   return () => {
  //     document.head.removeChild(metaDescription);
  //     document.head.removeChild(metaKeywords);
  //     document.head.removeChild(script);
  //   };
  // }, []);
  
  return (
    <>
      <Helmet>
        <title>About Us | Anyworq – A to Z Services in Bangalore</title>
        <meta
          name="description"
          content="Learn about Anyworq – Bangalore’s trusted A-to-Z service marketplace. Discover our mission, vision, values, and how we connect customers with verified service providers for all needs."
        />
        <meta
          name="keywords"
          content="Anyworq Bangalore, About Anyworq, A to Z services Bangalore, verified dealers Bangalore, home services Bangalore, business services Bangalore, service marketplace India, trusted service providers Bangalore"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.anyworq.com/about-us" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="About Anyworq – A to Z Services in Bangalore"
        />
        <meta
          property="og:description"
          content="Discover Anyworq’s story – Bangalore’s trusted platform for verified home, business, and personal services."
        />
        <meta property="og:url" content="https://www.anyworq.com/about-us" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.anyworq.com/Favicon.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Anyworq – A to Z Services in Bangalore"
        />
        <meta
          name="twitter:description"
          content="Connecting customers with verified service providers across Bangalore."
        />
        <meta
          name="twitter:image"
          content="https://www.anyworq.com/Favicon.png"
        />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Anyworq",
              "url": "https://www.anyworq.com",
              "logo": "https://www.anyworq.com/Favicon.png",
              "sameAs": [
                "https://www.facebook.com/anyworq",
                "https://www.instagram.com/anyworq",
                "https://www.linkedin.com/company/anyworq"
              ],
              "description": "Anyworq is Bangalore’s first-of-its-kind A-to-Z service marketplace connecting customers with verified service providers.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Bangalore",
                "addressCountry": "India"
              },
              "areaServed": {
                "@type": "Place",
                "name": "Bangalore, India"
              },
              "foundingDate": "2025",
              "slogan": "One Platform. All Services. Bangalore’s Choice."
            }
          `}
        </script>
      </Helmet>
      <MainHeader />
      <div className="aboutus-container">
        {/* Header */}
        <header className="aboutus-header">
          <h1>About Us</h1>
        </header>

        {/* Intro */}
        <section className="aboutus-section">
          <p>
            Welcome to <b>Anyworq</b> – India’s first-of-its-kind platform designed to transform the 
            way services are delivered and consumed. We bring together <b>customers and verified 
            service providers</b> on a single, secure, and technology-driven platform that ensures 
            <b>trust, transparency, and convenience</b> at every step.
          </p>
        </section>

        {/* Vision */}
        <section className="aboutus-section">
          <h2>Our Vision</h2>
          <p>
            To become India’s most trusted <b>A-to-Z service marketplace</b>, where every customer 
            finds the right solution quickly, and every business finds genuine opportunities to grow.
          </p>
        </section>

        {/* What We Do */}
        <section className="aboutus-section">
          <h2>What We Do</h2>
          <h4>At Anyworq, we make life easier for customers and businesses by offering: </h4>
          <ul>
            <li>
              <strong>One-Stop Access:</strong> From home maintenance and
              personal services to business solutions and beyond – we cover
              almost every service need under one roof.
            </li>
            <li>
              <strong>Verified Providers:</strong> Every vendor is thoroughly
              vetted before being onboarded, ensuring reliability and
              professionalism.
            </li>
            <li>
              <strong>Budget-Friendly Matching:</strong> Customers share their
              budget, and we connect them with the most suitable providers who
              fit both their needs and price point.
            </li>
            <li>
              <strong>Seamless Transactions:</strong> Customers pay their budget
              upfront to Anyworq, and upon successful completion of the service,
              we release payments to vendors after deducting a small service
              fee.
            </li>
            <li>
              <strong>Service Monitoring:</strong> Customers can track and
              monitor each stage of the service process for complete peace of
              mind.
            </li>
          </ul>
        </section>

        {/* Why Choose */}
        <section className="aboutus-section highlight">
          <h2>Why Choose Anyworq?</h2>
          <ul>
            <li>✅ Trust & Security – Our motto is to provide a safe and transparent environment for both customers and service providers.</li>
            <li>✅ Hassle-Free Experience – No more wasting time searching for the right vendor; we make the match for you.</li>
            <li>
              ✅ Fair Resolution – – In case of disputes, we guide both parties to resolve issues amicably, avoiding unnecessary complications.</li>
            <li>✅ Win-Win for All – Customers enjoy stress-free services, and providers gain easy access to genuine leads.</li>
          </ul>
        </section>

        {/* Journey Ahead */}
        <section className="aboutus-section">
          <h2>Our Journey Ahead</h2>
          <p>
            We are proud to begin our operations in <b>Bangalore</b>, the hub of innovation and services. 
            With a strong foundation in place, our next phase is to <b>expand across cities and eventually 
            nationwide</b>, making Anyworq India’s go-to platform for all service needs.
          </p>
          <p>At Anyworq, we don’t just connect people to services – <b>we redefine trust, simplify 
            transactions, and empower growth</b>. Whether you are a customer seeking reliable service 
            or a business looking for assured leads, Anyworq is the partner you can depend on.</p>
        </section>

        {/* Mission */}
        <section className="aboutus-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to bridge the gap between customers and service providers in Bangalore. 
            Finding the right professional should never be complicated, and with Anyworq, it isn’t. 
            We bring A-to-Z services under one roof and make them easily accessible to everyone in 
            the city through a smart, transparent, and professional system.
          </p>
          <p><b>We believe in:</b></p>
          <ul>
            <li>
              Making service access simple and efficient for every customer.
            </li>
            <li>
              Empowering local dealers and service providers by creating more 
              genuine business opportunities.
            </li>
            <li>
              Ensuring customer satisfaction with high-quality, verified, and
              trustworthy services.
            </li>
          </ul>
        </section>

        {/* What We Offer */}
        <section className="aboutus-section">
          <h2>What We Offer</h2>
          <p>
            At Anyworq, we are proud to be Bangalore’s one-stop platform for every service 
            imaginable. Our mission is to connect customers with verified professionals across 
            all industries and service categories, making every requirement—big or small—simple, 
            fast, and hassle-free.
          </p>
          <p>We cover services across industries such as:</p>
          <ul>
            <li>
              <strong>Home & Lifestyle:</strong> Plumbing, electrical, carpentry,
              painting, cleaning, pest control, appliance repair, and more.
            </li>
            <li>
              <strong>Construction & Real Estate:</strong> Contractors, interior
              design, architecture, renovation, property management, real estate
              support.
            </li>
            <li>
              <strong>Business & Professional Services:</strong> IT solutions, digital marketing, 
              accounting, HR support, logistics, consulting, legal, finance, and other corporate 
              services.
            </li>
            <li>
              <strong>Personal & Wellness Services:</strong> Event planning,
              beauty & wellness, fitness training, healthcare, lifestyle
              services.
            </li>
            <li>
              <strong>Travel, Automotive & Specialized Services:</strong> Travel bookings, 
              automobile care, aviation, hospitality, education, entertainment, and other niche sectors.
            </li>
          </ul>
          <p>Whether it’s a small household task, a complex business project, or a highly specialized 
            service, Anyworq ensures you are connected to the right professional in Bangalore quickly, 
            transparently, and without hassle.</p>
            <p>With Anyworq, if there’s a service in the world, you can find it, book it, and get it 
              done—all under one trusted platform.</p>

        </section>

        {/* Dealer Profile System */}
        <section className="aboutus-section">
          <h2>Our Unique Dealer Profile System</h2>
          <p>
            One of the features that makes Anyworq truly unique is our Dealer Profile System. Every 
            dealer or service provider on our platform has a dedicated profile highlighting their 
            expertise, experience, and customer reviews.
          </p>
          <p>
            When you submit a service enquiry, our system automatically assigns it to the most suitable
             dealer based on your specific requirements. This ensures faster response times, higher 
             quality service, and complete transparency.
          </p>
          <p>
            Customers can track their enquiries in real-time and communicate directly with the assigned 
            dealers, keeping them informed and in control throughout the process.
          </p>
          <p>
            By combining advanced technology with trust, Anyworq guarantees that every service request is 
            handled professionally, efficiently, and reliably.
          </p>
        </section>

        {/* Why in Bangalore */}
        <section className="aboutus-section">
          <h2>Why Choose Anyworq in Bangalore?</h2>
          <p>Bangalore is a fast-growing city with endless service demands, and Anyworq is here to make 
            finding the right service fast, simple, and reliable. Choosing Anyworq gives you access to:</p>
          <ul>
            <li>✅ <b>A-to-Z Services in One Place</b> - – From household tasks to business solutions, find every service you need without browsing multiple platforms.</li>
            <li>✅ <b>Verified and Trusted Dealers</b> – Every service provider is carefully vetted for professionalism, experience, and reliability.</li>
            <li>✅ <b>Local Expertise – We focus exclusively on Bangalore, ensuring dealers understand the city’s unique requirements.</b></li>
            <li>✅ <b>Customer-First Approach – Your time, trust, and satisfaction are our top priorities.</b></li>
            <li>✅ <b>Quick and Efficient Enquiry Handling – Our system guarantees fast responses and proper service assignment through our unique dealer profile system.</b></li>
            <li>✅ <b>Transparency and Professionalism – Track your service stages, communicate directly with assigned dealers, and experience hassle-free service delivery.</b></li>
          </ul>
          <p>We are committed to making Anyworq the most reliable, trustworthy, and convenient service platform in Bangalore, connecting customers with the right professionals every time.</p>
        </section>

        {/* Target Audience */}
        <section className="aboutus-section">
  <h2>Our Target Audience</h2>
  <p>
    At <strong>Anyworq</strong>, we cater to everyone in Bangalore who seeks reliable, 
    verified service providers. Our platform is designed to serve a wide range of customers, including:
  </p>
  <ul>
    <li>
      <strong>Individuals & Families –</strong> For household repairs, maintenance, cleaning, 
      and personal services.
    </li>
    <li>
      <strong>Businesses & Startups –</strong> For professional, IT, corporate, 
      and operational services.
    </li>
    <li>
      <strong>Property Owners & Dealers –</strong> For real estate support, 
      interior design, renovation, and facility management.
    </li>
    <li>
      <strong>Event Organizers & Planners –</strong> For catering, décor, rentals, 
      logistics, and event management services.
    </li>
  </ul>
  <p>
    No matter who you are or what your needs may be, <strong>Anyworq</strong> provides 
    the right solution quickly, efficiently, and hassle-free.
  </p>
</section>


        {/* Values */}
        <section className="aboutus-section">
  <h2>Our Values, Vision, and Promise</h2>
  <ul>
    <li><strong>Innovation –</strong> Continuously improving our platform to make service access smarter and more efficient.</li>
    <li><strong>Trust –</strong> Connecting you only with verified and professional dealers you can rely on.</li>
    <li><strong>Customer Satisfaction –</strong> Your happiness and peace of mind are our top priorities.</li>
    <li><strong>Transparency –</strong> No hidden charges, no surprises—just clear, reliable service at every step.</li>
    <li><strong>Local Empowerment –</strong> Supporting Bangalore-based dealers and service providers by creating genuine business opportunities.</li>
  </ul>

  {/* Vision for Bangalore */}
  <h3>Our Vision for Bangalore</h3>
  <p>
    Bangalore, the Silicon Valley of India, still faces challenges in easy access 
    to quality services. Our vision is to make <strong>Anyworq</strong> the most 
    trusted A-to-Z service platform in Bangalore, where finding the right service 
    provider is just a click away.
  </p>
  <p>
    By combining technology, local expertise, and a strong dealer network, we are 
    building a future-ready service ecosystem for the city, ensuring that customers 
    and businesses alike can access services quickly, reliably, and transparently.
  </p>

  {/* Our Promise */}
  <h3>Our Promise</h3>
  <p>When you choose <strong>Anyworq</strong>, you choose:</p>
  <ul>
    <li><strong>Convenience –</strong> All services under one platform.</li>
    <li><strong>Quality –</strong> Verified dealers delivering excellent results.</li>
    <li><strong>Trust –</strong> Transparency and professionalism in every transaction.</li>
    <li><strong>Local Expertise –</strong> Services tailored to the unique needs of Bangalore.</li>
  </ul>
  <p>
    We promise to always put our customers first and continuously evolve our 
    platform to serve you better.
  </p>

  {/* Conclusion */}
  <h3>Conclusion</h3>
  <p>
    At <strong>Anyworq</strong>, we are more than just a service platform. We are 
    Bangalore’s trusted partner for A-to-Z services, committed to simplifying lives 
    and empowering local dealers.
  </p>
  <p>
    Whether you are an individual, family, or business, <strong>Anyworq</strong>  
    ensures that every enquiry finds the right solution, every time.
  </p>
</section>


        {/* Conclusion */}
        <footer className="aboutus-footer">
          <p>
            <strong>Anyworq – One Platform. All Services. Bangalore’s Choice.</strong>
          </p>
        </footer>
      </div>
      <HomeFooter />
    </>
  );
}
